import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { NonAuthRoutes, Modules } from '../../enums';
import { AuthContext } from '../../contexts/AuthContext';
import { Permissions } from '../../interfaces/common';
import { hasResourseAccess } from '../../utils/methods';
import Layout from '../Layout/Private';

interface ProtectedRouteProps {
  component: any;
  accessibleTo?: Permissions[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, accessibleTo }) => {
  const Component = component;
  const {
    token, permissions, isSystemAdmin
  } = useContext(AuthContext);

  if (!token) {
    return <Navigate replace to={{ pathname: Modules.auth + NonAuthRoutes.login }} />;
  }

  if (!hasResourseAccess(isSystemAdmin, permissions, accessibleTo ? { accessibleTo } : null)) {
    return <Navigate replace to={{ pathname: Modules.error + NonAuthRoutes.forbidden }} />;
  }

  return (
    <Layout>
      <Component />
    </Layout>
  );
};

export default ProtectedRoute;
